import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.SET_CURRENT_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/setCurrentCategory.js